"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchSubscriptionImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing SearchSubscription operations. */
var SearchSubscriptionImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class SearchSubscription class.
   * @param client Reference to the service client
   */
  function SearchSubscriptionImpl(client) {
    (0, _classCallCheck2["default"])(this, SearchSubscriptionImpl);
    this.client = client;
  }
  /**
   *  (Auth: Authorize)
   * @param portalId
   * @param options The options parameters.
   */


  (0, _createClass2["default"])(SearchSubscriptionImpl, [{
    key: "getSearchSubscriptionsByCurrentUser",
    value: function getSearchSubscriptionsByCurrentUser(portalId, options) {
      var operationArguments = {
        portalId: portalId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getSearchSubscriptionsByCurrentUserOperationSpec);
    }
    /**
     *  (Auth: Authorize)
     * @param portalId
     * @param email
     * @param subscriptionId
     * @param options The options parameters.
     */

  }, {
    key: "getSearchSubscriptionByEmail",
    value: function getSearchSubscriptionByEmail(portalId, email, subscriptionId, options) {
      var operationArguments = {
        portalId: portalId,
        email: email,
        subscriptionId: subscriptionId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getSearchSubscriptionByEmailOperationSpec);
    }
    /**
     * @param portalId
     * @param email
     * @param subscriptionId
     * @param body
     * @param options The options parameters.
     */

  }, {
    key: "updateSearchSubscriptionByEmailAccount",
    value: function updateSearchSubscriptionByEmailAccount(portalId, email, subscriptionId, body, options) {
      var operationArguments = {
        portalId: portalId,
        email: email,
        subscriptionId: subscriptionId,
        body: body,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, updateSearchSubscriptionByEmailAccountOperationSpec);
    }
    /**
     * @param portalId
     * @param email
     * @param subscriptionId
     * @param options The options parameters.
     */

  }, {
    key: "deleteSearchSubscriptionByEmailAccount",
    value: function deleteSearchSubscriptionByEmailAccount(portalId, email, subscriptionId, options) {
      var operationArguments = {
        portalId: portalId,
        email: email,
        subscriptionId: subscriptionId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, deleteSearchSubscriptionByEmailAccountOperationSpec);
    }
    /**
     * @param portalId
     * @param email
     * @param subscriptionId
     * @param options The options parameters.
     */

  }, {
    key: "confirmSubscription",
    value: function confirmSubscription(portalId, email, subscriptionId, options) {
      var operationArguments = {
        portalId: portalId,
        email: email,
        subscriptionId: subscriptionId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, confirmSubscriptionOperationSpec);
    }
    /**
     * @param portalId
     * @param email
     * @param options The options parameters.
     */

  }, {
    key: "getSearchSubscriptionsByEmailAccount",
    value: function getSearchSubscriptionsByEmailAccount(portalId, email, options) {
      var operationArguments = {
        portalId: portalId,
        email: email,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getSearchSubscriptionsByEmailAccountOperationSpec);
    }
    /**
     *  (Auth: Authorize)
     * @param portalId
     * @param body
     * @param options The options parameters.
     */

  }, {
    key: "createSearchSubscription",
    value: function createSearchSubscription(portalId, body, options) {
      var operationArguments = {
        portalId: portalId,
        body: body,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, createSearchSubscriptionOperationSpec);
    }
    /**
     *  (Auth: Authorize)
     * @param portalId
     * @param subscriptionId
     * @param body
     * @param options The options parameters.
     */

  }, {
    key: "updateSearchSubscriptionByCurrentUser",
    value: function updateSearchSubscriptionByCurrentUser(portalId, subscriptionId, body, options) {
      var operationArguments = {
        portalId: portalId,
        subscriptionId: subscriptionId,
        body: body,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, updateSearchSubscriptionByCurrentUserOperationSpec);
    }
    /**
     *  (Auth: Authorize)
     * @param portalId
     * @param subscriptionId
     * @param options The options parameters.
     */

  }, {
    key: "deleteSearchSubscriptionByCurrentUser",
    value: function deleteSearchSubscriptionByCurrentUser(portalId, subscriptionId, options) {
      var operationArguments = {
        portalId: portalId,
        subscriptionId: subscriptionId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, deleteSearchSubscriptionByCurrentUserOperationSpec);
    }
  }]);
  return SearchSubscriptionImpl;
}(); // Operation Specifications


exports.SearchSubscriptionImpl = SearchSubscriptionImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var getSearchSubscriptionsByCurrentUserOperationSpec = {
  path: "/api/Portals({portalId})/User/SearchSubscriptions",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "SearchSubscriptionInfo"
            }
          }
        }
      }
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getSearchSubscriptionByEmailOperationSpec = {
  path: "/api/Portals({portalId})/EmailAccounts({email})/SearchSubscriptions({subscriptionId})",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.SearchSubscriptionInfo
    },
    401: {},
    403: {}
  },
  queryParameters: [Parameters.ticket],
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.email, Parameters.subscriptionId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var updateSearchSubscriptionByEmailAccountOperationSpec = {
  path: "/api/Portals({portalId})/EmailAccounts({email})/SearchSubscriptions({subscriptionId})",
  httpMethod: "PUT",
  responses: {
    200: {}
  },
  requestBody: Parameters.body23,
  queryParameters: [Parameters.ticket],
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.email, Parameters.subscriptionId],
  headerParameters: [Parameters.contentType],
  mediaType: "json",
  serializer: serializer
};
var deleteSearchSubscriptionByEmailAccountOperationSpec = {
  path: "/api/Portals({portalId})/EmailAccounts({email})/SearchSubscriptions({subscriptionId})",
  httpMethod: "DELETE",
  responses: {
    200: {}
  },
  queryParameters: [Parameters.ticket],
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.email, Parameters.subscriptionId],
  serializer: serializer
};
var confirmSubscriptionOperationSpec = {
  path: "/api/Portals({portalId})/EmailAccounts({email})/SearchSubscriptions({subscriptionId})/Confirm",
  httpMethod: "PUT",
  responses: {
    200: {
      bodyMapper: Mappers.SearchSubscriptionInfo
    }
  },
  queryParameters: [Parameters.ticket],
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.email, Parameters.subscriptionId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getSearchSubscriptionsByEmailAccountOperationSpec = {
  path: "/api/Portals({portalId})/EmailAccounts({email})/SearchSubscriptions",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "SearchSubscriptionInfo"
            }
          }
        }
      }
    }
  },
  queryParameters: [Parameters.ticket],
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.email],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var createSearchSubscriptionOperationSpec = {
  path: "/api/Portals({portalId})/SearchSubscriptions",
  httpMethod: "POST",
  responses: {
    200: {
      bodyMapper: Mappers.SearchSubscriptionInfo
    },
    401: {},
    403: {}
  },
  requestBody: Parameters.body23,
  urlParameters: [Parameters.$host, Parameters.portalId],
  headerParameters: [Parameters.accept, Parameters.contentType],
  mediaType: "json",
  serializer: serializer
};
var updateSearchSubscriptionByCurrentUserOperationSpec = {
  path: "/api/Portals({portalId})/User/SearchSubscriptions({subscriptionId})",
  httpMethod: "PUT",
  responses: {
    200: {},
    401: {},
    403: {}
  },
  requestBody: Parameters.body23,
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.subscriptionId],
  headerParameters: [Parameters.contentType],
  mediaType: "json",
  serializer: serializer
};
var deleteSearchSubscriptionByCurrentUserOperationSpec = {
  path: "/api/Portals({portalId})/CurrentUser/SearchSubscriptions({subscriptionId})",
  httpMethod: "DELETE",
  responses: {
    200: {},
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.subscriptionId],
  serializer: serializer
};